import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { IOperationColumn, ITotalValue } from '../../models/vessel-kpi'
import { VesselKpiTableCell } from '../atoms/VesselKpiTableCell'

interface Props {
  column: IOperationColumn
  total: ITotalValue
}
export const TotalTableFooter = observer(({ column, total }: Props) => (
  <Grid container>
    {column.hasInbound && <VesselKpiTableCell column={column} skipTotal value={total.inbound} />}
    {column.hasOutbound && <VesselKpiTableCell column={column} skipTotal value={total.outbound} />}
    {column.hasRestow && <VesselKpiTableCell column={column} skipTotal value={total.restow} />}
  </Grid>
))
